module.exports = __webpack_public_path__ + "img/Path 15@3x.d06a17ae.png";